import React from "react";
import NavbarAbout from "../../components/NavbarAbout";
import { Helmet } from "react-helmet";
import { useTranslation } from "react-i18next";
import { analytics, EVENTS } from "../../analytics";
import { useNavigate } from "react-router-dom";

const ResultsPage: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const section = t("resultsPage", { returnObjects: true }) as any;

  return (
    <div className="flex flex-col min-h-screen bg-white">
      <Helmet>
        <title>BeMe – Results & Success Stories</title>
        <meta
          name="description"
          content="Explore BeMe’s success stories: global career offers from clients who prepared for the UK job market with expert consulting."
        />
      </Helmet>

      <NavbarAbout />

      {/* Brand Intro */}
      <section className="py-24 px-4 bg-white">
        <div className="max-w-3xl mx-auto text-center">
          <p className="text-sm font-semibold tracking-widest text-accent uppercase mb-4">About BeMe</p>
          <h1 className="text-4xl md:text-5xl font-bold text-main mb-6 leading-tight">
            가장 영국스럽게,<br />하지만 가장 나답게
          </h1>
          <p className="text-lg text-gray-600 leading-relaxed mb-8">
            BeMe는 단순한 교정 서비스가 아닙니다.<br />
            여러분의 진짜 강점과 경험을 영국 채용 시장에서 통하는 언어로 번역해드립니다.
          </p>
          <div className="border-t border-gray-100 pt-8 grid md:grid-cols-3 gap-8 text-left">
            <div>
              <p className="text-2xl font-bold text-main mb-2">10년+</p>
              <p className="text-sm text-gray-500">영국 현직 커리어 경험을 바탕으로 한 컨설팅</p>
            </div>
            <div>
              <p className="text-2xl font-bold text-main mb-2">Be Authentic</p>
              <p className="text-sm text-gray-500">서류에서 인터뷰까지, 나다운 스토리로 승부합니다</p>
            </div>
            <div>
              <p className="text-2xl font-bold text-main mb-2">UK-First</p>
              <p className="text-sm text-gray-500">영국 채용 기준을 가장 잘 아는 팀이 함께합니다</p>
            </div>
          </div>
        </div>
      </section>

      {/* Hero Section */}
      <section className="py-20 text-center bg-sub">
        <h1 className="text-4xl md:text-5xl font-bold text-main mb-4">
          {section.hero.title}
        </h1>
        <p className="text-gray-700 text-lg md:text-xl max-w-2xl mx-auto">
          {section.hero.subtitle}
        </p>
      </section>

      {/* Career Offers */}
      <section className="py-24 px-4 text-center bg-white">
        <h2 className="text-3xl font-bold text-main mb-2">{section.careerOffers.title}</h2>
        <p className="text-gray-600 mb-10">{section.careerOffers.subtitle}</p>

        <div className="flex flex-wrap justify-center gap-10 max-w-6xl mx-auto">
          {section.careerOffers.companies.map((c: any, idx: number) => (
            <div key={idx} className="flex flex-col items-center">
              <img
                src={c.img}
                alt={c.name}
                className="w-64 h-64 object-contain mb-3"
              />
              <p className="font-medium text-main text-base">{c.name}</p>
            </div>
          ))}
        </div>
      </section>

      {/* CTA */}
      <section className="py-20 px-4 text-center">
        <h2 className="text-3xl font-bold text-main mb-6">{section.cta.title}</h2>
        <p className="text-gray-700 text-lg mb-8 max-w-2xl mx-auto">{section.cta.subtitle}</p>
        <button
           onClick={() => {
            navigate("/service");
            window.scrollTo({ top: 0, behavior: "smooth" });
            analytics.track(EVENTS.CLICK_RESULTS_TO_SERVICE);
          }}
          className="inline-block bg-accent text-main px-8 py-3 rounded-lg font-semibold shadow-md hover:bg-yellow-600 hover:text-white transition-colors"
        >
          {section.cta.button}
        </button>
    
      </section>

      
    </div>
  );
};

export default ResultsPage;
